export const getAnalysisFieldName = (field) => {
    return field.split('.').join('.fields.');
};
